import React, { useState, useEffect } from 'react';
import Card from '../Reusable/Card';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import SmsHistoryContent from './SmsHistory/SmsHistoryContent';
import EmailHistoryContent from './EmailHistory/EmailHistoryContent';


const tabTitles = {
  sms_history: 'SMS History',
  email_history: 'Email History'
};

const HistoryNavLink = ({ setActiveTitle }) => {
  const [activeTab, setActiveTab] = useState('sms_history');

  useEffect(() => {
    if (setActiveTitle) {
      setActiveTitle(tabTitles[activeTab]);
    }
  }, [activeTab, setActiveTitle]);

  const renderContent = () => {
    switch (activeTab) {
      case 'sms_history':
        return <SmsHistoryContent />;
        case 'email_history' :
          return <EmailHistoryContent />
      default:
        return null;
    }
  };

  const buttonClass = (sms_history) =>
    tw` outline-none focus:outline-none focus:ring-0 ${
      activeTab === sms_history
        ? 'border-b-2 border-primary text-primary font-semibold'
        : 'border-b-0 text-gray-600 hover:text-primary'
    }`;

  return (
    <div>
      <Card>
        <div className='flex gap-4 border-b p-4 text-lg'>
          <button
            className={buttonClass('sms_history')}
            onClick={() => setActiveTab('sms_history')}
          >
            SMS History
          </button>
          <button
            className={buttonClass('email_history')}
            onClick={() => setActiveTab('email_history')}
          >
            Email History
          </button>
        </div>
      </Card>

      <div className='mt-4'>{renderContent()}</div>
    </div>
  );
};

export default HistoryNavLink;
